export default class ProjectModel {
    constructor(id, name, number) {
        this.id = id;
        this.name = name;
        this.number = number;
    }
}



// WEBPACK FOOTER //
// ./src/models/project.js